import { Route, Redirect } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) => {
      const token = localStorage.getItem("token");
      try {
        const decodedToken = jwtDecode(token);
        return jwtDecode(localStorage.getItem("token") || "")?.sub ? (
          <Component {...props} />
        ) : (
          <>
            <Redirect to="/auth/login" />
            <Component {...props} />
          </>
        );
      } catch (e) {
        return (
          <>
            <Redirect to="/auth/login" />
            <Component {...props} />
          </>
        );
      }
    }}
  />
);

export default PrivateRoute;
